// import * as React from 'react';
import DragContainer from './DragContainer';
import DragCard from './DragCard';
export default {
    Container: DragContainer,
    Card: DragCard,
};



// WEBPACK FOOTER //
// ./components/drag/index.tsx